/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import L from "../Lang"
import BaseCom from "../BaseCom";
import Breadcrumb from "../Breadcrumb";
import DataTable from "../DataTable";
import Icon from "../Icon";
import { SidebarGlobal } from "../_Sidebar";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class SurveySubmissions extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            query: {
                page: 1,
                sort: 'o.createddate DESC',
                qfilters: {}
            },
            preColumns: [
                /*{ icon: 'Eye', link: '/survey/' + this.props.params.surveyID + '/submission/:id', tooltip: 'View Submission' }*/
                { name: 'createdDate', title: 'Created', format: 'datetime' },
                {
                    name: 'score', title: 'Score', valueFunc: row => {
                        return String(row.score ?? 0);
                    }
                }
            ],
            columns: [],
            totalCount: 0,

        };
        this.load = this.load.bind(this);
        this.onSort = this.onSort.bind(this);
        this.export = this.export.bind(this);
    }

    componentDidMount() {
        this.load();
        SidebarGlobal.setSubNav(<div className="bt-group">
            <button type="button" className="btn btn-primary" onClick={this.export}><Icon icon="faFileExcel" /> <L>Export CSV</L></button>
        </div>);
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load() {
        qreq.get('/api/survey/get/' + this.props.params.surveyID, j => {
            if (j.item) {
                var columns = [...this.state.preColumns];
                j.item.pages.forEach(p => {
                    p.items.forEach(i => {
                        if (i.itemType === 'label')
                            return;
                        columns.push({ name: i.ident, title: i.content, link: null /* '/survey/' + this.props.params.surveyID + '/submission/:id' */, tooltip: 'View Submission' });
                    });
                });
                this.setState({ survey: j.item, columns: columns });
                qreq.post('/api/survey/submission/' + this.props.params.surveyID + '/list', { ...this.state.query }, j => {
                    if (j.list) {
                        Globals.processResultObject(j);
                        this.setState({ list: j.list, totalCount: j.totalCount, loaded: true });
                    }
                    else
                        this.alert(j.errorMessage);
                }, this.unkownErrorCallback);
            }
        });
    }

    export() {
        window.open(Globals.serverUrl + '/api/survey/submission/' + this.props.params.surveyID + '/export');
    }

    onSort(col) {

    }

    render() {
        return <div className="container-fluid">
            <h1><L>Submissions</L></h1>
            <Breadcrumb path={[['Survey', '/survey'], ['Submissions']]} />
            <DataTable columns={this.state.columns} data={this.state.list} loading={this.state.loading} totalCount={this.state.totalCount} onSort={null} />
        </div>;
    }
}

export default withParamsAndNavigate(SurveySubmissions);